import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { brand } from '../mock';

export default function ContactInfo() {
  return (
    <div className="lg:col-span-5">
      <span className="text-[#F4B93E] uppercase tracking-[0.25em] font-black text-xs">Book a free demo</span>
      <h2 className="mt-3 text-3xl lg:text-5xl font-black leading-[1.05]">
        Let’s find your child <span className="text-[#F4B93E]">the right tutor.</span>
      </h2>
      <p className="mt-4 text-[#FFF8EC]/80 text-lg">
        Share a few details and our counsellor will call you back within 30 minutes.
      </p>

      <div className="mt-8 space-y-4">
        <a href={`tel:${brand.phoneRaw}`} className="flex items-center gap-4 bg-white/5 hover:bg-white/10 border border-white/20 rounded-xl p-4">
          <div className="w-12 h-12 rounded-lg bg-[#F4B93E] text-[#2C3E50] flex items-center justify-center"><Phone size={20} /></div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#FFF8EC]/60">Call us</div>
            <div className="font-black text-lg">{brand.phone}</div>
          </div>
        </a>
        <a href={`tel:${brand.phone2Raw}`} className="flex items-center gap-4 bg-white/5 hover:bg-white/10 border border-white/20 rounded-xl p-4">
          <div className="w-12 h-12 rounded-lg bg-[#7BB7DC] text-[#2C3E50] flex items-center justify-center"><Phone size={20} /></div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#FFF8EC]/60">Alternate</div>
            <div className="font-black text-lg">{brand.phone2}</div>
          </div>
        </a>
        <a href={`mailto:${brand.email}`} className="flex items-center gap-4 bg-white/5 hover:bg-white/10 border border-white/20 rounded-xl p-4">
          <div className="w-12 h-12 rounded-lg bg-[#4FB3B8] text-[#2C3E50] flex items-center justify-center"><Mail size={20} /></div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#FFF8EC]/60">Email</div>
            <div className="font-bold">{brand.email}</div>
          </div>
        </a>
        <div className="flex items-center gap-4 bg-white/5 border border-white/20 rounded-xl p-4">
          <div className="w-12 h-12 rounded-lg bg-[#E64B2B] text-white flex items-center justify-center"><MapPin size={20} /></div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#FFF8EC]/60">Head office</div>
            <div className="font-bold">{brand.address}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
